import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import PageLoader from '@/components/base/PageLoader';

/**
 * ルート共通の認証ガード。
 * - 認証状態の読み込み中はローディング画面を表示
 * - 未ログインの場合はログインページへリダイレクト（戻り先を redirect クエリに保持）
 * - ログイン済みの場合のみ子ルート（保護ページ）を描画
 */
export default function AuthGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <PageLoader />
    );
  }

  if (!user) {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return <Outlet />;
}